module.exports = __webpack_public_path__ + "media/images/projects/10-header-c575762ec92b05df9424a5df8313bbe0.jpg";